import axios from 'axios';
export const UPLOAD_FILE = '[CTM TFT] UPLOAD FILE';
export const LIST_FILE_IN_PROJECT  = '[CTM TFT] LIST FILE IN PROJECT';
export const GET_TFT_FROM_TD  = '[CTM TFT] GET TFT FROM TD';

export function uploadFile(projectCode) {
	return async (dispatch, getState) => {
		/*let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];

		const config = {
			headers: { Authorization: `Token ${token}` }
		};
		const bodyParameters = {

		};
		
		const request = await axios.post(process.env.REACT_APP_SERVER + 'api/ctm/tft-data/', 
									bodyParameters,
									config                      
		)
        .then(response => {

        })
        .catch(function (error) {
            if (error.response) {
              // Request made and server responded
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              // The request was made but no response was received
              console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
            }
            return dispatch({
                type: ERROR_API,
            });
        
        });*/


		return dispatch({
			type: UPLOAD_FILE,
		});
	}

}

export const listFileInProject = (projectCode) => async dispatch => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    let projectCode = "XKT777771"
    const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/tft-data/'+projectCode+'/', {
        headers: { Authorization: `Token ${token}` }
    });

    return request.then(response => {
        if (response.data.data) {
        return dispatch({
            type: LIST_FILE_IN_PROJECT,
            data: response.data.data,
        });
        } else {
        //reject(response.data.error);
        }
    });
};

export const getTftFromTD = () => async dispatch => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];
    let project = JSON.parse(localStorage.getItem('persistProjectSelected'));
    let projectCode = project['projectCode'];
    let ctm = JSON.parse(localStorage.getItem('ctm'));
    let tunnelDistance = ctm['TFTSelected'];
    const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/tft-data/detail?const_cd='+projectCode+'&tunnel_dist='+tunnelDistance, {
        headers: { Authorization: `Token ${token}` }
    });

    return request.then(response => {
        if (response.data.data) {
        return dispatch({
            type: GET_TFT_FROM_TD,
            data: response.data.data,
        });
        } else {
        //reject(response.data.error);
        }
    });
};
